import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ShiftChecker = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const userId = localStorage.getItem('user_id');
    const companyId = localStorage.getItem('company_id');
    const branchId = localStorage.getItem('branch_id');

    // Check if we have the necessary data
    if (!userId || !companyId || !branchId) {
      // Handle missing data (optional)
      console.error('User ID, Company ID, or Branch ID not found in local storage.');
      return;
    }

    const checkOpenShift = async () => {
      try {
        const response = await fetch(`http://localhost:3009/shift/shiftdetails/${userId}/${companyId}/${branchId}`);
        
        if (!response.ok) {
          throw new Error('Failed to fetch shift details');
        }

        const data = await response.json();

        // Check if there is an open shift
        if (data.status === 'open') {
          navigate('/XGoDashboard');
        } else {
          navigate('/XGoOpenShift');
        }
      } catch (error) {
        console.error('Error checking open shift:', error);
        // Handle error (e.g., show a notification or redirect)
      }
    };

    checkOpenShift();
  }, [navigate]);

  return null; // Or a loading spinner while checking
};

export default ShiftChecker;